import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdAdd,
  MdArrowForwardIos,
  MdBookmark,
  MdBookmarkBorder,
  MdCheckCircle,
  MdCloud,
  MdFolder,
  MdMenu,
  MdOutlineShoppingCart,
  MdPerson,
  MdPersonOutline,
  MdShoppingCart,
} from "react-icons/md";

import "../styles/Calendar.css";
import Spinner from "../components/Spinner";
import { useNavigate } from "react-router";
import { isEmpty } from "../functions/isEmpty";
import Component_Calendar from "../components/Calendar";
import GoogleCalendarButton from "../components/GoogleCalendarButton";

export default function Calendar({
  apiURL,
  isMobile,
  chats,
  scrollPositionHome,
  setScrollPositionHome,
  operators,
  user,
  searchString,
  setSearchString,
  setActiveOperator,
  activeContact,
  setActiveContact,
  activeOperator,
  documents,
  files,
  setFiles,
  customers,
  messages,
  connections,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [calendarConnection, setCalendarConnection] = useState({});
  const [appointments, setAppointments] = useState([]);
  const [sortedData, setSortedData] = useState([]);
  let navigate = useNavigate();

  const handleClick = (chats_id, sendername) => {
    let searchedOperatorID = 0;
    let searchedOperator = {};
    if (!isEmpty(sendername)) {
      console.log(sendername);
      setActiveContact(sendername);
    }
    chats.map((chat, index) => {
      if (chat.id == chats_id) {
        searchedOperatorID = chat.operators_id;
      }
    });

    operators.map((operator, index) => {
      if (operator.id == searchedOperatorID) {
        searchedOperator = operator;
      }
    });
    setActiveOperator(searchedOperator);

    navigate("/chats/" + chats_id);
  };

  useEffect(() => {
    connections.map((conn, index) => {
      if (conn.type == "calendar") {
        setCalendarConnection(conn);
        return;
      }
    });
  }, [connections]);

  useEffect(() => {
    const filtered = messages
      .filter(
        (msg) =>
          msg.sender !== "ai" &&
          msg.sender !== "user" &&
          msg.type == "calendar_event"
      )
      .reduce((acc, msg) => {
        const existing = acc[msg.sender];
        const notSeen = msg.seen === 0 ? 1 : 0;

        if (!existing) {
          acc[msg.sender] = { ...msg, notseencount: notSeen };
        } else {
          if (msg.createdAt > existing.createdAt) {
            acc[msg.sender] = {
              ...msg,
              notseencount: existing.notseencount + notSeen,
            };
          } else {
            acc[msg.sender].notseencount += notSeen;
          }
        }

        return acc;
      }, {});

    const sorted = Object.values(filtered).sort(
      (a, b) => b.createdAt - a.createdAt
    );

    setSortedData(sorted);
  }, [messages]);

  function formatTimestamp(unixTimestamp) {
    // Überprüfe, ob der Timestamp eine gültige Zahl ist
    if (isNaN(unixTimestamp)) {
      return "";
    }

    const date = new Date(unixTimestamp * 1000); // Unix-Timestamp in Sekunden
    const now = new Date();

    // Prüfe, ob das Datum vom heutigen Tag ist
    if (date.toDateString() === now.toDateString()) {
      // Formatierung: hh:mm
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      return `${hours}:${minutes}`;
    }

    // Berechne den Unterschied in Tagen
    const startOfToday = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );
    const startOfDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );
    const diffTime = startOfToday - startOfDate;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    // Wenn genau 1 Tag Unterschied: "gestern"
    if (diffDays === 1) {
      return "Gestern";
    }

    // Liegt die Nachricht zwischen 1 und 6 Tagen zurück?
    if (diffDays < 7) {
      // Deutscher Wochentag
      const weekdays = [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag",
      ];
      return weekdays[date.getDay()];
    } else {
      // Mehr als 7 Tage zurück: Format dd.mm.yy
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear().toString().slice(-2);
      return `${day}.${month}.${year}`;
    }
  }

  useEffect(() => {
    if (isEmpty(user)) {
      let authData = localStorage.getItem("@ditochat_user");
      if (!isEmpty(authData)) {
        navigate("/login");
      }
    }
    setActiveContact(null);
  }, [user]);

  const createNewMail = (operator) => {
    setActiveOperator(operator);
    chats.map((chat) => {
      if (chat.operators_id == operator.id) {
        navigate("/chats/" + chat.id);
      } else {
        navigate("/chats/0");
      }
    });
  };

  const calendar_events = [
    {
      id: 1,
      message: "Projekt Kick-off\nErstes Meeting zur Projektbesprechung\r\n",
      type: "calendar_event",
      chats_id: "16",
      tasks_id: "",
      files_id: "",
      users_id: "35",
      customers_id: "",
      automations_id: "0",
      sender: "Masih Minawal <masih@pcpilot.io>",
      receiver: "testserver@ditochat.com",
      thirdparty_id: "<238af368-53a6-4544-9b0c-86bd4ff873cc@pcpilot.io>",
      automations_content:
        "Betreff: AW: test\n\nHallo Masih,\n\nvielen Dank für deine Nachricht. Mir geht es gut, und ich hoffe, dass auch bei dir alles in Ordnung ist.\n\nSolltest du weitere Fragen oder Anliegen haben, stehe ich jederzeit gerne zur Verfügung.\n\nBeste Grüße,\n\n[Dein Name]",
      automations_status: "draft",
      seen: "1",
      status: "1",
      createdAt: 1744982313,
      end_time: 1745014713,
      thirdparty_createdAt: 1744982313,
    },
    {
      id: 2,
      message: "Projekt Kick-off\nErstes Meeting zur Projektbesprechung\r\n",
      type: "calendar_event",
      chats_id: "16",
      tasks_id: "",
      files_id: "",
      users_id: "35",
      customers_id: "",
      automations_id: "0",
      sender: "Masih Minawal <masih@pcpilot.io>",
      receiver: "testserver@ditochat.com",
      thirdparty_id: "<238af368-53a6-4544-9b0c-86bd4ff873cc@pcpilot.io>",
      automations_content:
        "Betreff: AW: test\n\nHallo Masih,\n\nvielen Dank für deine Nachricht. Mir geht es gut, und ich hoffe, dass auch bei dir alles in Ordnung ist.\n\nSolltest du weitere Fragen oder Anliegen haben, stehe ich jederzeit gerne zur Verfügung.\n\nBeste Grüße,\n\n[Dein Name]",
      automations_status: "draft",
      seen: "1",
      status: "1",
      createdAt: 1744982313,
      end_time: 1745014713,
      thirdparty_createdAt: 1744982313,
    },
  ];

  const placeholder = [
    { date: "2025-04-01", label: "Termin mit Masih" },
    { date: "2025-04-02", label: "Termin mit Masih" },
    { date: "2025-04-03", label: "Termin mit Masih" },
    { date: "2025-04-18", label: "Termin mit Masih" },
    { date: "2025-05-02", label: "Termin mit Masih" },
  ];

  const params = new URLSearchParams(window.location.search);
  const status = params.get("status");

  if (status === "already_connected") {
    alert("Diese Verbindung besteht bereits.");
  }
  if (status === "connected") {
    alert("Google Kalender erfolgreich verbunden!");
  }

  return (
    <div className="account">
      <div className="calendar_topnav">
        <div className="calendar_topnav_headline">Termine</div>
        <div className="home_topnav_menubtn" onClick={() => navigate("/menu")}>
          <MenuIcon />
        </div>
      </div>

      <div className="calendar_body">
        <div className="calendar_body_customers">
          {isEmpty(calendarConnection) && (
            <>
              <div className="inbox_connectbtn">
                <GoogleCalendarButton user={user} environment={"test"} />
              </div>
              <div className="inbox_connectbtn">
                <GoogleCalendarButton user={user} environment={"live"} />
              </div>
            </>
          )}
          {!isEmpty(calendarConnection) && (
            <Component_Calendar appointments={appointments} />
          )}
        </div>
      </div>
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 30px;
  color: #474747;
`;

const ArrowForwardIcon = styled(MdArrowForwardIos)`
  font-size: 15x;
  color: #bababa;
`;

const CloudIcon = styled(MdFolder)`
  font-size: 18px;
  color: #474747;
`;

const CheckIcon = styled(MdCheckCircle)`
  font-size: 25px;
  color: #0072f5;
`;

const AddIcon = styled(MdAdd)`
  font-size: 23px;
  color: #0072f5;
`;

const FolderIcon = styled(MdFolder)`
  font-size: 23px;
  color: rgb(114, 114, 114);
`;

const AccountIcon = styled(MdPerson)`
  font-size: 23px;
  color: rgb(114, 114, 114);
`;
